module.exports = __webpack_public_path__ + "media/images/marisol-play-c678e546e62a07e92769f3cb37d4814e.jpg";